import { appRoutes, resourcesRoute as route } from '@utils/consts';
import { ResourcesProvider } from '@contexts/resources';

const routes = [
  {
    path: appRoutes.resources.acceptInvitation,
    lazy: async () => {
      const { AcceptInvitation } = await import('@pages/resources/acceptInvitation');
      return {
        Component: () => <AcceptInvitation />,
      };
    },
  },
  {
    path: route.index,
    lazy: async () => {
      const { ResourcesRoot } = await import('@components/resources');
      return {
        Component: () => (
          <ResourcesProvider>
            <ResourcesRoot />
          </ResourcesProvider>
        ),
      };
    },
    children: [
      {
        path: appRoutes.base,
        lazy: async () => {
          const { Resources } = await import('@pages/resources');
          return {
            Component: () => <Resources />,
          };
        },
      },
      {
        path: route.office,
        lazy: async () => {
          const { ResourcesOffice } = await import('@pages/resources/office');
          return {
            Component: () => <ResourcesOffice />,
          };
        },
      },
      {
        path: route.fieldWorkers,
        lazy: async () => {
          const { ResourcesFieldWorkers } = await import('@pages/resources/fieldWorkers');
          return {
            Component: () => <ResourcesFieldWorkers />,
          };
        },
      },
      {
        path: route.equipment,
        lazy: async () => {
          const { ResourcesEquipment } = await import('@pages/resources/equipment');
          return {
            Component: () => <ResourcesEquipment />,
          };
        },
      },
    ],
  },
];

export { routes as resourcesRoutes };
